<template>
	<main id="container" class="page-container event-delivery-page">
		<div class="page-content">
			<div class="container">
				<section>
					<!-- 코그페 메인 타이틀 영역 -->
					<div class="conTitArea line">
						<h2>이벤트 안내</h2>
					</div>

					<div class="detailCon">
						<!-- tab -->
						<div class="tab tabFunc">
							<div class="tabMenu mScrollArea">
								<ul class="lineBtn">
									<li :class="{ curr: isTabActive('purchase') }">
										<router-link to="/ko/event/purchase">소비인증 캠페인</router-link>
									</li>
									<li :class="{ curr: isTabActive('store') }">
										<router-link to="/ko/event/store">코그페 스토어 인증</router-link>
									</li>
									<li :class="{ curr: isTabActive('delivery') }">
										<router-link to="/ko/event/delivery">공공배달앱 할인</router-link>
									</li>
									<li :class="{ curr: isTabActive('dineOut') }">
										<router-link to="/ko/event/DineOut">전통시장 이벤트</router-link>
									</li>
								</ul>
							</div>

							<div class="tabCon">
								<div v-show="activeTab === 1" style="display: block" id="tab5">
									<h3 class="hide">공공배달앱 할인</h3>
									<div class="multipleLinkBannerArea" ref="bannerArea">
										<picture>
											<source
												media="(max-width: 767px)"
												srcset="/images/img-event-m-tab-041.png"
											/>
											<img
												ref="bannerImg"
												src="/images/img-event-tab-04.png"
												alt="공공배달앱 할인 이벤트 안내"
												@load="updateBannerBtns"
											/>
										</picture>
										<div class="multiLinkWrap">
											<a
												v-for="(item, idx) in deliveryApps"
												:key="idx"
												:href="item.href"
												class="grBannerBtn"
												:aria-label="item.label"
												target="_blank"
												rel="noopener noreferrer"
												:style="{
													position: 'absolute',
													right: item.pcRight + 'px',
													bottom: item.pcBottom + 'px',
												}"
												:data-mo-right="item.moRight"
												:data-mo-bottom="item.moBottom"
												:data-pc-right="item.pcRight"
												:data-pc-bottom="item.pcBottom"
											>
												<span>바로가기</span>
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!--// tab -->
					</div>
				</section>
			</div>
		</div>
	</main>
</template>

<script>
export default {
	name: 'EventDelivery',
	data() {
		return {
			activeTab: 1,
			resizeObserver: null,
			deliveryApps: [
				{
					name: '땡겨요',
					href: 'https://fdofd.ddangyo.com/gateway4.html?tK20tGn',
					label: '땡겨요 이벤트 자세히 보기',
					pcRight: 228,
					pcBottom: 2574,
					moRight: 80,
					moBottom: 940,
				},
				{
					name: '대구로',
					href: 'https://app.daeguro.co.kr/app/public_link.html?project=DELIVERY&action=ACTION_LINK_EVENT&eventCode=3968',
					label: '대구로 이벤트 자세히 보기',
					pcRight: 228,
					pcBottom: 2380,
					moRight: 80,
					moBottom: 870,
				},
				{
					name: '배달의명수',
					href: 'https://user.baedalmyeongsu.com/noticeView.user?bbsId=BBSMSTR_000000000001&nttId=1798',
					label: '배달의명수 이벤트 자세히 보기',
					pcRight: 228,
					pcBottom: 2184,
					moRight: 80,
					moBottom: 800,
				},
				{
					name: '먹깨비',
					href: 'https://www.mukkebi.com/hana.php?bd_idx=89323&bc_code=event_user',
					label: '먹깨비 이벤트 자세히 보기',
					pcRight: 228,
					pcBottom: 1986,
					moRight: 80,
					moBottom: 726,
				},
				{
					name: '배달의특급',
					href: 'https://app.specialdelivery.co.kr/customer/event?idx=EV00005523',
					label: '배달의특급 이벤트 자세히 보기',
					pcRight: 228,
					pcBottom: 1788,
					moRight: 80,
					moBottom: 650,
				},
				{
					name: '위메프오',
					href: 'https://www.wmpo.co.kr/events/3163744',
					label: '위메프오 이벤트 자세히 보기',
					pcRight: 228,
					pcBottom: 1590,
					moRight: 80,
					moBottom: 576,
				},
				{
					name: '휘파람',
					href: 'https://delivery.whee-param.kr/U/M/Event/View/1389',
					label: '휘파람 이벤트 자세히 보기',
					pcRight: 228,
					pcBottom: 1392,
					moRight: 80,
					moBottom: 504,
				},
				{
					name: '전주맛배달',
					href: 'https://user.jjorder.com/eventListView.user?bbsId=BBSMSTR_000000000031&nttId=1543',
					label: '전주맛배달 이벤트 자세히 보기',
					pcRight: 228,
					pcBottom: 1194,
					moRight: 80,
					moBottom: 430,
				},
				{
					name: '시장을방으로',
					href: 'https://oligopalgo.com/board/board_view.php?bc_code=notice&bd_idx=945',
					label: '시장을방으로 이벤트 자세히 보기',
					pcRight: 228,
					pcBottom: 996,
					moRight: 80,
					moBottom: 360,
				},
			],
		};
	},
	mounted() {
		window.scrollTo(0, 0);
		window.addEventListener('resize', this.handleResize);

		this.$nextTick(() => {
			this.updateBannerBtns();
			setTimeout(this.updateBannerBtns, 100);
			setTimeout(this.updateBannerBtns, 300);
			setTimeout(this.updateBannerBtns, 600);
		});

		if (window.ResizeObserver && this.$refs.bannerArea) {
			this.resizeObserver = new ResizeObserver(() => {
				this.updateBannerBtns();
			});
			this.resizeObserver.observe(this.$refs.bannerArea);
		}
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
	},
	methods: {
		isTabActive(tab) {
			const path = (this.$route && this.$route.path ? this.$route.path : '').toLowerCase();
			if (tab === 'purchase') return path.includes('purchase');
			if (tab === 'store') return path.includes('store');
			if (tab === 'delivery') return path.includes('delivery');
			if (tab === 'linked') return path.includes('linked');
			return false;
		},
		handleResize() {
			this.updateBannerBtns();
		},
		updateBannerBtns() {
			const area = this.$refs.bannerArea;
			if (!area) return;

			const img = area.querySelector('picture > img');
			if (!img || !img.naturalWidth) return;

			const imgWidth = img.getBoundingClientRect().width;
			if (!imgWidth) return;

			const isMobile = window.matchMedia('(max-width: 767px)').matches;
			const baseWidth = isMobile ? 767 : 2084;
			const scale = imgWidth / baseWidth;

			const btns = area.querySelectorAll('.grBannerBtn');
			btns.forEach((btn) => {
				if (!btn.dataset.pcRight) {
					btn.dataset.pcRight = parseFloat(btn.style.right);
					btn.dataset.pcBottom = parseFloat(btn.style.bottom);
				}

				const right = isMobile
					? parseFloat(btn.dataset.moRight)
					: parseFloat(btn.dataset.pcRight);
				const bottom = isMobile
					? parseFloat(btn.dataset.moBottom)
					: parseFloat(btn.dataset.pcBottom);

				if (!Number.isFinite(right) || !Number.isFinite(bottom)) return;

				btn.style.right = right * scale + 'px';
				btn.style.bottom = bottom * scale + 'px';
				btn.style.transform = `scale(${scale})`;
				btn.style.transformOrigin = 'right bottom';
			});
		},
	},
};
</script>

<style scoped>
@font-face {
	font-family: 'Gmarket Sans';
	font-weight: 700;
	src: url('/fonts/GmarketSansBold.woff2') format('woff2'),
		url('/fonts/GmarketSansBold.woff') format('woff');
}
@font-face {
	font-family: 'Gmarket Sans';
	font-weight: 500;
	src: url('/fonts/GmarketSansMedium.woff2') format('woff2'),
		url('/fonts/GmarketSansMedium.woff') format('woff');
}

/* 페이지 전체 배경 초기화 (코그페와 완전 동일하게 순백색 배경 적용) */
.page-container.event-delivery-page {
	background: #ffffff !important;
	background-image: none !important;
}

.event-delivery-page .page-content {
	margin-top: 0 !important;
	margin-bottom: 60px !important;
	padding-top: 20px !important;
	padding-bottom: 60px !important;
	background: #ffffff !important;
	background-image: none !important;
}

.event-delivery-page .container {
	max-width: 1640px;
	margin: 0 auto;
	padding: 0 20px;
}

/* 코그페 메인 타이틀 영역 */
.conTitArea {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 40px 0 30px;
}

.conTitArea.line {
	border-bottom: 2px solid #000;
}

.conTitArea h2 {
	font-weight: 700;
	font-size: 34px;
	color: #000;
	margin: 0;
}

/* 탭 메뉴 */
.detailCon {
	margin: 40px auto 0;
}

.tabMenu.mScrollArea {
	width: 100%;
	overflow-x: auto;
}

.tabMenu ul {
	display: flex;
	align-items: center;
	gap: 10px;
	list-style: none;
	padding: 0;
	margin: 0;
}

.tabMenu .lineBtn {
	justify-content: flex-start;
	gap: 20px;
}

.tabMenu .lineBtn li {
	flex-shrink: 0;
	min-width: 103px;
	background: #fff;
	border-radius: 8px;
	border: 1px solid #11194f;
	overflow: hidden;
}

.tabMenu .lineBtn li a {
	display: block;
	padding: 13px 24px;
	width: 100%;
	border: none;
	font-weight: 400;
	color: #11194f;
	font-size: 20px;
	text-align: center;
	letter-spacing: -1.2px;
	text-decoration: none;
}

.tabMenu ul.lineBtn li.curr a,
.tabMenu ul.lineBtn li a.router-link-exact-active,
.tabMenu ul.lineBtn li a:hover {
	background: #252c5d;
	color: #fff !important;
	font-weight: 700;
}

.tabCon {
	padding: 30px 0 100px 0;
}

.hide {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	border: 0;
}

/* 공공배달앱 다중 링크 배너 영역 */
.multipleLinkBannerArea {
	position: relative;
	width: 100%;
	max-width: 1600px;
	margin: 0 auto;
}

.multipleLinkBannerArea picture,
.multipleLinkBannerArea picture > img {
	display: block;
	width: 100%;
	height: auto;
}

.multiLinkWrap {
	position: absolute;
	inset: 0;
	pointer-events: none;
}

a.grBannerBtn {
	display: block;
	box-sizing: border-box;
	pointer-events: auto;
	transform-origin: right bottom;
	color: #fff !important;
	background-color: #00ab69;
	width: 218px;
	height: 80px;
	border-radius: 12px;
	text-align: center;
	line-height: 80px;
	font-size: 48px;
	font-family: 'Gmarket Sans', 'Pretendard', -apple-system, sans-serif;
	font-weight: 700;
	text-decoration: none;
	transition: filter 0.2s ease;
}

a.grBannerBtn:hover {
	filter: brightness(1.08);
}

a.grBannerBtn span {
	display: inline-block;
}

/* 미디어 쿼리 반응형 */
@media (max-width: 1280px) {
	.tabMenu ul {
		gap: 30px;
		width: 100%;
	}
}

@media (max-width: 940px) {
	.tabMenu ul li a {
		line-height: 23px;
		font-size: 20px;
	}

	.tabMenu .lineBtn {
		gap: 10px;
	}
}

@media (max-width: 768px) {
	.conTitArea {
		padding: 30px 0 20px;
	}

	.conTitArea h2 {
		font-size: 26px;
	}

	.detailCon {
		margin-top: 24px;
	}

	.tabMenu .lineBtn li a {
		padding: 10px 18px;
		font-size: 16px;
	}

	.tabCon {
		padding: 20px 0 60px 0;
	}
}

@media (max-width: 767px) {
	.tabMenu {
		padding-bottom: 0px;
	}

	.tabMenu ul {
		gap: 20px;
		padding-bottom: 20px !important;
		flex-wrap: nowrap !important;
	}

	.tabMenu ul li a {
		font-size: 17px;
	}

	.tabMenu .lineBtn li a {
		padding: 8px 18px;
		line-height: inherit;
		font-size: 18px;
	}

	a.grBannerBtn {
		font-size: 21px;
		width: 100px;
		height: 38px;
		line-height: 38px;
		border-radius: 8px;
	}
}
</style>
